"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useMemo, useState } from "react";
import type { ApiDrop, ApiWave } from "@/generated/models/ObjectSerializer";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import WaveDropsAll from "../drops/wave-drops-all";
import { CreateDropWaveWrapper, CreateDropWaveWrapperContext } from "../CreateDropWaveWrapper";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
import { ActiveDropAction } from "@/types/dropInteractionTypes";
import PrivilegedDropCreator, { DropMode } from "../PrivilegedDropCreator";
import { useAndroidKeyboard } from "@/hooks/useAndroidKeyboard";
interface SingleWaveDropChatProps {
  readonly wave: ApiWave;
  readonly drop: ApiDrop;
}
export const SingleWaveDropChat: React.FC<SingleWaveDropChatProps> = t0 => {
  const $ = _c(28);
  const {
    wave,
    drop
  } = t0;
  const {
    isApp
  } = useDeviceInfo();
  const {
    isVisible: isKeyboardVisible
  } = useAndroidKeyboard();
  const t1 = isKeyboardVisible ? "0px" : "calc(env(safe-area-inset-bottom))";
  let t2;
  if ($[0] !== t1) {
    t2 = {
      paddingBottom: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const inputContainerStyle = t2;
  let t3;
  if ($[2] !== drop) {
    t3 = {
      action: ActiveDropAction.REPLY,
      drop,
      partId: 1
    };
    $[2] = drop;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const [activeDrop, setActiveDrop] = useState(t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = t5 => {
      const {
        drop: drop_0,
        partId,
        action
      } = t5;
      setActiveDrop({
        action,
        drop: drop_0,
        partId
      });
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleDropAction = t4;
  let t5;
  if ($[5] !== drop) {
    t5 = () => {
      setActiveDrop({
        action: ActiveDropAction.REPLY,
        drop,
        partId: 1
      });
    };
    $[5] = drop;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const resetActiveDrop = t5;
  let t6;
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = t8 => {
      const {
        drop: drop_1,
        partId: partId_0
      } = t8;
      return handleDropAction({
        drop: drop_1,
        partId: partId_0,
        action: ActiveDropAction.REPLY
      });
    };
    t7 = t9 => {
      const {
        drop: drop_2,
        partId: partId_1
      } = t9;
      return handleDropAction({
        drop: drop_2,
        partId: partId_1,
        action: ActiveDropAction.QUOTE
      });
    };
    $[7] = t6;
    $[8] = t7;
  } else {
    t6 = $[7];
    t7 = $[8];
  }
  const t8 = wave.metrics?.muted ?? false;
  let t9;
  if ($[9] !== activeDrop || $[10] !== drop.id || $[11] !== t8 || $[12] !== wave.id) {
    t9 = <div className="tw-flex-1 tw-min-h-0"><WaveDropsAll waveId={wave.id} onReply={t6} onQuote={t7} activeDrop={activeDrop} initialDrop={null} dropId={drop.id} isMuted={t8} /></div>;
    $[9] = activeDrop;
    $[10] = drop.id;
    $[11] = t8;
    $[12] = wave.id;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== inputContainerStyle || $[15] !== isApp) {
    t10 = isApp ? inputContainerStyle : {
      paddingBottom: "calc(env(safe-area-inset-bottom))"
    };
    $[14] = inputContainerStyle;
    $[15] = isApp;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== activeDrop || $[18] !== drop.id || $[19] !== resetActiveDrop || $[20] !== wave) {
    t11 = <CreateDropWaveWrapper context={CreateDropWaveWrapperContext.SINGLE_DROP}><PrivilegedDropCreator activeDrop={activeDrop} onCancelReplyQuote={resetActiveDrop} onDropAddedToQueue={resetActiveDrop} wave={wave} dropId={drop.id} fixedDropMode={DropMode.BOTH} /></CreateDropWaveWrapper>;
    $[17] = activeDrop;
    $[18] = drop.id;
    $[19] = resetActiveDrop;
    $[20] = wave;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10 || $[23] !== t11) {
    t12 = <div style={t10} className="tw-mt-auto">{t11}</div>;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12 || $[26] !== t9) {
    t13 = <div className="tw-flex-1 tw-flex tw-flex-col tw-h-full tw-min-h-0"><div className="tw-flex-1 tw-flex tw-flex-col tw-min-h-0 tw-overflow-hidden tw-bg-iron-950 tw-relative lg:tw-border tw-border-l-0 lg:tw-border-r lg:tw-border-solid tw-border-iron-800 tw-border-y-0"><div className="tw-flex-1 tw-flex tw-flex-col tw-min-h-0 tw-relative"><div className="tw-w-full tw-flex tw-flex-col tw-flex-1 tw-min-h-0"><div className="tw-w-full tw-flex tw-flex-col tw-flex-1 tw-min-h-0">{t9}{t12}</div></div></div></div></div>;
    $[25] = t12;
    $[26] = t9;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
};